import { render, staticRenderFns } from "./CreateUserView.vue?vue&type=template&id=007e703d&scoped=true&"
import script from "./CreateUserView.vue?vue&type=script&lang=js&"
export * from "./CreateUserView.vue?vue&type=script&lang=js&"
import style0 from "./CreateUserView.vue?vue&type=style&index=0&id=007e703d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007e703d",
  null
  
)

export default component.exports